import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import "./ProductHeaderV2.css";
import ScoreV2 from "../../components/v2/ScoreV2";
import countries from '../../pages/v2/jsons/countries.json';

const ProductHeaderV2 = ({ product_info, score, handleNavigation, shouldDisplayIndexTab }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const imgRef = useRef(null);
  const imageSrc = Array.isArray(product_info.img)
    ? product_info.img[0]
    : product_info.img;
  const thumbnailBlur = product_info.thumbnailBlur;
  const [isMobile] = useState(() => {
    if (typeof window !== "undefined") {
      return window.matchMedia("(max-width: 768px)").matches;
    }
    return false;
  });

  const getCountryDescription = (code) => {
    const country = countries.find((country) => country.code === code);
    return country ? country.description.en : "Unknown Country";
  };

  useEffect(() => {
    setImageLoaded(false);
    setLoading(true);

    if (!imageSrc) return undefined;

    const img = new Image();
    let active = true;
    img.src = imageSrc;
    img.onload = () => {
      if (!active) return;
      setImageLoaded(true);
      setLoading(false);
    };
    return () => { active = false; };
  }, [imageSrc]);

  const handleImageClick = () => {
    const img = imgRef.current;
    const rect = img.getBoundingClientRect();
    const initialPosition = {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
    };

    localStorage.setItem("initialPosition", JSON.stringify(initialPosition));
    handleNavigation();
  };

  const renderHeaderImage = () => (
    <div className="v2-product-header-img-frame">
      {thumbnailBlur ? (
        <img
          src={thumbnailBlur}
          alt=""
          aria-hidden="true"
          className={`v2-product-header-img-placeholder v2-product-header-img-placeholder-blur ${imageLoaded ? "loaded" : ""}`}
        />
      ) : (
        loading && <div className="v2-product-header-img-placeholder" />
      )}
      <CSSTransition
        in={imageLoaded}
        timeout={400}
        classNames="v2-image-fade-header"
        unmountOnExit
        appear
      >
        <button type="button" className="v2-product-header-image-button" onClick={handleImageClick} aria-label="Abrir produto">
          <img
            ref={imgRef}
            className="v2-product-header-img"
            alt=""
            src={imageSrc}
          />
        </button>
      </CSSTransition>
    </div>
  );

  return isMobile ? (
    <div
      className={`v2-product-header-container ${
        shouldDisplayIndexTab ? "" : "without-score"
      }`}
    >
      {renderHeaderImage()}
      {shouldDisplayIndexTab ? (
        <div className="v2-product-header-text-score-container">
          <div className="v2-product-header-text-container">
            <div className="v2-product-header-text-name-v2">
              {product_info.name[0].description}
            </div>
            <div className="v2-product-header-text-brand-v2">
              {product_info.brand}
            </div>
          </div>
          <ScoreV2 score={score} />
        </div>
      ) : (
        <div className="v2-product-header-text-score-container">
          <div className="v2-product-header-text-container">
            <div className="v2-product-header-text-name-v2">
              {product_info.name[0].description}
            </div>
            <div className="v2-product-header-text-brand-v2">
              {product_info.brand}
            </div>
          </div>
          <div className="v2-product-header-text-name-v2 madein">
            Made In {getCountryDescription(product_info.made_in)}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="v2-product-header-container">
      {renderHeaderImage()}
      <div className="v2-product-header-text-score-container">
        <div className="v2-product-header-text-container">
          <div className="v2-product-header-text-name-v2">
            {product_info.name[0].description}
          </div>
          <div className="v2-product-header-text-brand-v2">
            {product_info.brand}
          </div>
        </div>
        <ScoreV2 score={score} />
      </div>
    </div>
  );
};

export default ProductHeaderV2;
